"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99181],{

/***/ 87303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgDigit4 = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 90,
  height: 90,
  viewBox: "0 0 90 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M35.161 51.58v-4.692L45.905 31.52H52.4v15.028h2.788v5.032H52.4V56h-5.814v-4.42H35.161Zm11.832-13.668-5.712 8.636h5.712v-8.636Z",
  fill: "#000"
})));
/* harmony default export */ __webpack_exports__["default"] = (SvgDigit4);

/***/ })

}]);